export const getToken = () => sessionStorage.getItem("access_token");
export const getTenantId = () => JSON.parse(sessionStorage.getItem("vendorData")).tenant_id;

export const getAppUserTypes = () => {
  try { return JSON.parse(sessionStorage.getItem("appUserType") ?? "[]"); }
  catch { return []; }
};

export const orAll = (arr) => (arr.length === 0 ? ["all"] : arr);

export const sum = (arr, key) =>
  (arr ?? []).reduce((acc, r) => acc + (Number(r[key]) || 0), 0);

export const POINTS_RANGE_OPTIONS = [
  { value: "0-100", label: "0 – 100" },
  { value: "100-1000", label: "100 – 1,000" },
  { value: "1000-5000", label: "1,000 – 5,000" },
  { value: "5000-10000", label: "5,000 – 10,000" },
  { value: "Above 10000", label: "Above 10,000" },
];

// Extracts filtered_stats from raw API response
export const getFilteredStats = (stats) =>
  stats?.body?.filtered_stats ?? stats?.filtered_stats ?? null;
